import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { UrlService } from './url.service';

@Injectable({
    providedIn: 'root',
})
export class CustomerSearchService {
    constructor(private urlService: UrlService, private httpService: HttpService) {}

    public findCustomers(keyword: string): Observable<FindCustomerRecord[]> {
        const url = this.urlService.getUrl('findCustomers', { keyword });
        return this.httpService.get(url);
    }
}

interface FindCustomerRecord {
    name: string;
    number: string;
    calculationSchema: string;
}
